import React, {useEffect} from 'react'
import {Link, useParams} from "react-router-dom";
import LogoDark from "../assets/images/logo-dark@2x.png";
import useApi from "../useApi";
import {useAlert} from 'react-alert'
import {getPass} from '../api'
import PassImg from '../assets/images/pass.jpg'


function AndroidPay(props) {
    return React.createElement(
        'g:savetoandroidpay',
        props
    )
}


export default function Pass() {

    const {id} = useParams();
    const alert = useAlert();
    const [{data}, get] = useApi({alert});

    useEffect(() => {
        if (id)
            get(getPass(id))
    }, [id, get]);

    useEffect(() => {
        if (data && data.jwt) {
            const script = document.createElement('script');
            script.src = "https://apis.google.com/js/platform.js";
            script.async = true;
            document.body.appendChild(script);
        }
    }, [data]);

    return (
        <div className="popup popup--terms is-active" id="popup-1">
            <div className="popup__container">
                <div className="popup__inner">
                    <Link to="/" className="popup__logo">
                        <img src={LogoDark} alt="" width="275" height="27"/>
                    </Link>

                    <div className="popup__content">
                        <div className="popup__head">
                            <h2 className="popup__title">{data.firstName}, your key to The Room</h2>
                        </div>

                        <div className="popup__entry">
                            <div style={{textAlign: "center"}}>
                                <img src={PassImg} alt="pass" style={{width: "250px"}}/>
                            </div>

                            <div style={{textAlign: "center"}}>
                                {data && data.jwt ?
                                    <AndroidPay
                                        jwt={data.jwt}
                                        size="small"
                                        theme="light"
                                        is="g"/> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}